module.exports = __webpack_public_path__ + "img/icon-profile-edition.7ade7aa1.svg";